import $ from 'jquery'

export function SmoothScroll () {
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault()
    scroll($.attr(this, 'href'))
  })

  if (window.location.hash) {
    const hash = window.location.hash
    const targetElement = document.querySelector(hash)
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

export function scroll (element) {
  $('html, body').animate({
    scrollTop: $(element).offset().top - getHeaderHeight()
  }, 800)
}

export function getHeaderHeight () {
  let height = 0
  const HEADER = document.querySelector('.mt-header')
  HEADER && (height += HEADER.getBoundingClientRect().height)
  const ADMIN_BAR = document.getElementById('wpadminbar')
  ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
  return height
}
